"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterCore = exports.verifyDateFormat = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var flow_1 = tslib_1.__importDefault(require("lodash/flow"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var react_responsive_1 = tslib_1.__importDefault(require("react-responsive"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var constants_1 = require("../constants");
var DateFilterButtonLocalized_1 = require("./DateFilterButtonLocalized/DateFilterButtonLocalized");
var DateFilterBody_1 = require("./DateFilterBody/DateFilterBody");
var PeriodExclusion_1 = require("./utils/PeriodExclusion");
var DateFilterTitle_1 = require("./utils/Translations/DateFilterTitle");
var Platform_1 = require("./constants/Platform");
var OptionUtils_1 = require("./utils/OptionUtils");
exports.verifyDateFormat = function (dateFormat) {
    try {
        // Try to format the current date to verify if dateFormat is a valid format.
        DateFilterTitle_1.formatAbsoluteDate(new Date(), dateFormat);
        return dateFormat;
    }
    catch (_a) {
        // If an error occurs, then dateFormat is invalid and the default format should be used instead. Also, a warning is written in the console.
        // eslint-disable-next-line no-console
        console.warn("Unsupported date format " + dateFormat + ", the default format " + Platform_1.DEFAULT_DATE_FORMAT + " is used instead.");
        return Platform_1.DEFAULT_DATE_FORMAT;
    }
};
exports.DateFilterCore = function (_a) {
    var originalSelectedFilterOption = _a.originalSelectedFilterOption, originalExcludeCurrentPeriod = _a.originalExcludeCurrentPeriod, onDropdownOpenChanged = _a.onDropdownOpenChanged, customFilterName = _a.customFilterName, dateFormat = _a.dateFormat, disabled = _a.disabled, locale = _a.locale, filterOptions = _a.filterOptions, dropdownBodyProps = tslib_1.__rest(_a, ["originalSelectedFilterOption", "originalExcludeCurrentPeriod", "onDropdownOpenChanged", "customFilterName", "dateFormat", "disabled", "locale", "filterOptions"]);
    var verifiedDateFormat = exports.verifyDateFormat(dateFormat);
    var filteredFilterOptions = react_1.useMemo(function () {
        return flow_1.default(OptionUtils_1.filterVisibleDateFilterOptions, OptionUtils_1.sanitizePresetIntervals)(filterOptions);
    }, [filterOptions]);
    return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: locale || "en-US" },
        react_1.default.createElement(react_responsive_1.default, { query: constants_1.MediaQueries.IS_MOBILE_DEVICE }, function (isMobile) {
            var dateFilterButton = function (isOpen) {
                if (isOpen === void 0) { isOpen = false; }
                return (react_1.default.createElement(DateFilterButtonLocalized_1.DateFilterButtonLocalized, { disabled: disabled, isMobile: isMobile, isOpen: isOpen, dateFilterOption: PeriodExclusion_1.applyExcludeCurrentPeriod(originalSelectedFilterOption, originalExcludeCurrentPeriod), dateFormat: verifiedDateFormat, customFilterName: customFilterName }));
            };
            return (react_1.default.createElement(sdk_ui_kit_1.Dropdown, { closeOnParentScroll: true, closeOnMouseDrag: true, closeOnOutsideClick: true, enableEventPropagation: true, alignPoints: [
                    { align: "bl tl" },
                    { align: "tr tl" },
                    { align: "br tr", offset: { x: -11 } },
                    { align: "tr tl", offset: { x: 0, y: -100 } },
                    { align: "tr tl", offset: { x: 0, y: -50 } },
                ], onOpenStateChanged: onDropdownOpenChanged, renderButton: function (_a) {
                    var isOpen = _a.isOpen, toggleDropdown = _a.toggleDropdown;
                    return (react_1.default.createElement("span", { onClick: disabled ? noop_1.default : toggleDropdown }, dateFilterButton(isOpen)));
                }, ignoreClicksOnByClass: [
                    ".s-do-not-close-dropdown-on-click",
                    ".DayPicker-Day",
                ], renderBody: function (_a) {
                    var closeDropdown = _a.closeDropdown;
                    return (
                    // Dropdown component uses React.Children.map and adds special props to this component
                    // https://stackoverflow.com/questions/32370994/how-to-pass-props-to-this-props-children
                    react_1.default.createElement(DateFilterBody_1.DateFilterBody, tslib_1.__assign({}, dropdownBodyProps, { filterOptions: filteredFilterOptions, isMobile: isMobile, closeDropdown: closeDropdown, dateFilterButton: dateFilterButton(), dateFormat: verifiedDateFormat })));
                } }));
        })));
};
//# sourceMappingURL=DateFilterCore.js.map